"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PayerContractStatusEnum = void 0;
var PayerContractStatusEnum = /*#__PURE__*/function (PayerContractStatusEnum) {
  PayerContractStatusEnum["COMPLETE"] = "complete";
  PayerContractStatusEnum["PENDING"] = "pending";
  return PayerContractStatusEnum;
}({});
exports.PayerContractStatusEnum = PayerContractStatusEnum;